module.exports = __webpack_public_path__ + "static/media/Phan_Nhat_Huy.1216daa0.jpg";